import { useState, useEffect } from 'react'
import StyledButton from '../../generic/StyledButton'
import DraggableModal from '../../generic/DraggableModal'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import { toPrice } from '../../../helpers/stringFormat'
import { backendPatchWithoutRefresh } from '../../../helpers/callBackend'

const CancelPaymentModal = ({ visible, handleCancelModal, paymentRequest, updatePaymentRequests }) => {
  const [amount, setAmount] = useState(toPrice(paymentRequest.amount || 0))
  const [method, setMethod] = useState(paymentRequest.method ? paymentRequest.method : 'ACH')
  const [counterPartyName, setCounterPartyName] = useState(
    paymentRequest.counterparty_name ? paymentRequest.counterparty_name : 'Unknown'
  )
  const cancelRequest = async () => {
    try {
      const cancelResp = await backendPatchWithoutRefresh('/api/payments/payment-request/', {
        cancel: true,
        payment_request_id: paymentRequest.id,
      })
      updatePaymentRequests(cancelResp.data?.data, "remove")
    } catch (error) {
      console.error(error)
    }
    handleCancelModal(false)
  }
  useEffect(() => {
    setAmount(toPrice(paymentRequest.amount))
    setMethod(paymentRequest.method ? paymentRequest.method : 'ACH')
    setCounterPartyName(paymentRequest.counterparty_name ? paymentRequest.counterparty_name : 'Unknown')
  }, [paymentRequest])
  return (
    <DraggableModal
      modalTitle="Cancel Payment"
      modalVisible={visible}
      handleCancelModal={handleCancelModal}
      width="50%"
      content={
        <Typography>{`Are you sure you want to cancel ${method} to ${counterPartyName} for ${amount}`}</Typography>
      }
      actions={
        <Stack direction="row" spacing={3} width="100%">
          <StyledButton label="Yes" fontSize={14} onClick={cancelRequest} />
          <StyledButton label="No" customTheme="outlined" fontSize={14} onClick={handleCancelModal} />
        </Stack>
      }
    />
  )
}

export default CancelPaymentModal
